import {AdminBatch, AdminCameras, AdminCollars, AdminConfigurationDevices, AdminDataLoggers, AdminDropOffs, AdminExternalSensors, AdminFirmwareVersions, AdminInternalRequest, AdminMovebank, AdminPayment, AdminTT4Sensors, AdminTraps, AdminUsers, AdminItems} from './api'
import {Injectable} from '@angular/core'

@Injectable({providedIn: 'root'})
export class AllServices {
  constructor(
    public AdminBatch: AdminBatch,
    public AdminCameras: AdminCameras,
    public AdminCollars: AdminCollars,
    public AdminConfigurationDevices: AdminConfigurationDevices,
    public AdminDataLoggers: AdminDataLoggers,
    public AdminDropOffs: AdminDropOffs,
    public AdminExternalSensors: AdminExternalSensors,
    public AdminFirmwareVersions: AdminFirmwareVersions,
    public AdminInternalRequest: AdminInternalRequest,
    public AdminMovebank: AdminMovebank,
    public AdminPayment: AdminPayment,
    public AdminTT4Sensors: AdminTT4Sensors,
    public AdminTraps: AdminTraps,
    public AdminUsers: AdminUsers,
    public AdminItems: AdminItems,
  ) {}
}